(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-kot-faq]:not([data-kot-ready])').forEach((faq) => {
      faq.dataset.kotReady = 'true';
      faq.querySelectorAll('details').forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          faq.querySelectorAll('details').forEach((other) => {
            if (other !== item) other.removeAttribute('open');
          });
        });
      });
    });
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
